( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'hero-promo';

	/**
	 * Init
	 */
	window.addEventListener( 'load', () => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Set block margin
	 *
	 * @param {object} block
	 */
	const setBlockMargin = ( block ) => {

		const content = block.querySelector( '.promo-hero-content' );
		if ( content && window.matchMedia( '(max-width: 1140px)' ).matches ) {

			block.style.marginBottom = `${ ( content.offsetHeight / 2 ) + 35 }px`;

		}

	}

	/**
	 * Block init
	 *
	 * @param {object} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {}

		// Block Code Here
		setBlockMargin( block );

	};

} )();
